export enum JiraStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}